import { createFeature, createReducer } from '@ngrx/store';

import { scheduleReducers } from './booking-schedule.reducer';
import { initialScheduleState } from './booking-schedule.state';

export const bookingScheduleFeature = createFeature({
  name: 'bookingSchedule',
  reducer: createReducer(initialScheduleState, ...scheduleReducers),
});
